export default "__VITE_ASSET__2a34a55e__"